export const FIND_EDOK_FORM_SUCCESS = 'FIND_EDOK_FORM_SUCCESS';

export const findEdokFormSuccess = form => ({
    type: FIND_EDOK_FORM_SUCCESS,
    payload: { form },
});
